var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{class:_vm.$style.button,attrs:{"text":"Download All","button-style":"accent"},on:{"click":function($event){return _vm.onClick($event)}}},[_c('app-svg-icon',{class:_vm.$style.icon,attrs:{"name":"ic_download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }